import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from 'src/app/services/http.service';
import phone from 'phone';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public logo: string = environment.logo;
  public loading: boolean = true;
  public error: string = null;
  public localError: string;
  public appData: any;
  public phoneNumber: string;
  public complete: boolean = false;
  public key: string;

  constructor(private http: HttpService){}

  ngOnInit(){
    this.loadProjectSettings();
  }

  private async loadProjectSettings(){
    const urlParams: any = new URLSearchParams(window.location.search);
    const key = urlParams.get("key");
    const type = urlParams.get("type");
  
    
    if(!key){
      this.error = "Missing authorization key";
      this.loading = false;
      return false;
    }
    if(!type){
      this.error = "Missing type";
      this.loading = false;
      return false;
    }
    this.key = key;
    const results: any = await this.http.postRequest("appstore/details",{type: type, key: key});
    if(results.error){
      this.error = results.error;
      this.loading = false;
      return false;
    }

    this.appData = results.res;
    this.error = null;
    this.loading = false;
  }

  public async submitUpdate(){
    this.loading = true;
    this.localError = null;
    const check: any = phone(this.phoneNumber);
    if(check.length == 0){
      this.localError = "Invalid phone number";
      this.loading = false;
      return false;
    }
    const results: any = await this.http.postRequest("appstore/update",{phone: check[0], key: this.key});

    if(results.error){
      this.localError = results.error;
      this.loading = false;
      return false;
    }

    this.complete = true;
    this.loading = false;


  }
}
